export default __webpack_public_path__ + "static/media/mic.75b87ae9.svg";